(function () {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js', {
                updateViaCache: 'none',
            })
                .then(function (registration) {
                    console.log('SW: Registration ok, waiting for subscription validation');


                    registration.onupdatefound = () => {
                        const installingWorker = registration.installing;
                        installingWorker.onstatechange = () => {
                            switch(installingWorker.state) {
                                case 'installed':
                                    if(navigator.serviceWorker.controller) {
                                        location.reload(true);
                                    } else {
                                        console.log('nothing to update');
                                    }
                                    break;
                            }
                        }
                    }

                    navigator.serviceWorker.ready
                        .then(swReg => {
                            swReg.pushManager.getSubscription()
                                .then(sub => {
                                    console.log('Subscripción', sub);
                                });
                        })
                        .catch(console.log);
                }).catch(registrationError => {
                    console.log('SW registration failed: ', registrationError);
                });
        });
    }
})();



// WEBPACK FOOTER //
// ./src/register-sw.js